import { ElectronicInvoiceReceiver } from 'src/modules/invoice/models/electronicInvoiceReceiver';
import { CrediflowParty } from 'src/modules/invoice/models/crediflowParty';
import { EInvoiceReceiverSearchFilter } from 'src/modules/invoice/models/eInvoiceReceiverSearchFilter';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';
import { setPagingParams } from '../functions/createPagingParams';

const controller = 'ElectronicInvoiceReceiver';

export const getAllElectronicInvoiceReceivers = (searchFilter: EInvoiceReceiverSearchFilter) => {
  const pageIndex = searchFilter?.pageIndex ?? 0;
  const pageSize = searchFilter?.pageSize ?? 50;
  const sortCol = searchFilter?.sortCol ?? 'id';
  const sortDir = searchFilter?.sortDir ?? 'desc';

  let extraQuery = '';
  extraQuery += searchFilter?.filter ? `&filter=${searchFilter.filter}` : '';

  const endpoint = `${controller}/?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}${extraQuery}`;
  return AxiosInstance.get<PagedResult<ElectronicInvoiceReceiver>>(endpoint);
};

export const getElectronicInvoiceReceiverById = (id: number) => {
  return AxiosInstance.get<ElectronicInvoiceReceiver>(`${controller}/${id}`);
};

export const createElectronicInvoiceReceiver = (data: ElectronicInvoiceReceiver) => {
  return AxiosInstance.post<ElectronicInvoiceReceiver>(controller, data);
};

export const updateElectronicInvoiceReceiver = (data: ElectronicInvoiceReceiver) => {
  return AxiosInstance.put<ElectronicInvoiceReceiver>(controller, data);
};

export const deleteElectronicInvoiceReceiver = (id: number) => {
  return AxiosInstance.delete(`${controller}/${id}`);
};

export const lookupElectronicInvoiceReceiverByCin = (cin: string, ownerId: number) => {
  return AxiosInstance.get<CrediflowParty[]>(`${controller}/Lookup?cin=${encodeURIComponent(cin)}&owner_id=${ownerId}`);
};

export const inviteElectronicInvoiceReceiver = (ownerId: number, invitedPartyId: number, email: string) => {
  return AxiosInstance.post(`${controller}/Invite`, { owner_id: ownerId, invitedPartyId, email });
};
